import React from "react";
import { Download, ExternalLink } from "lucide-react";
import BusinessCaseImg from "../../images/business-case.jpeg";
import SurvivalKindestImg from "../../images/SurvivalKindest.jpg";
import FirstImage from "../../images/media/1.png";
import SecondImage from "../../images/media/2.png";
import ThirdImage from "../../images/media/3.jpg";
import FourthImage from "../../images/media/4.jpg";
import FifthImage from "../../images/media/5.jpg";
import SixthImage from "../../images/media/6.jpg";
import SeventhImage from "../../images/media/7.jpg";
import EighthImage from "../../images/media/8.jpg";
import NinethImage from "../../images/media/9.jpg";
import TenthImage from "../../images/media/10.jpg";
import businessCase from "../../docs/IMA-Conclusions-Paper-The-Busines-Case-for-Kindness-November-2020.pdf";
import SurvivalKindest from "../../docs/Survival-of-the-Kindest-Article.pdf";
import PageLayout from "../ui/PageLayout";
import PageHero from "../ui/PageHero";
import FadeIn from "../ui/FadeIn";

const articles = [
  {
    image: BusinessCaseImg,
    title: "The Business Case for Kindness",
    body: `Popular belief holds that being kind is a risk in the cut - throat corporate world, where performance and productivity are prized.However, social scientists argue that prosocial behaviour at the workplace heightens employee engagement, promotes brand loyalty and improves business performance in the long run.

At a webinar of the IMA India CEO and CHRO Forums, Nirmala Mehendale, founder Trustee of Kindness Unlimited and Shailesh Haribhakti, one of the country's most prominent Chartered and Cost Accountants and an evangelist of the 'kindness movement', shared the principles of kindness in a post - Covid world and its impact on business performance.The paper summarises the thoughts shared.`,
    pdf: businessCase,
  },
  {
    image: SurvivalKindestImg,
    title: "Survival of the Kindest",
    body: `In a world obsessed with cutthroat competition, is kindness a weakness? Flip the script, and reveal how kindness is actually key to business success and a happier world. Discover how fostering a culture of compassion can boost productivity, employee satisfaction, and even help us tackle global challenges.  Read on and discover how to cultivate and lead a kinder, more successful workplace.`,
    pdf: SurvivalKindest,
  },
];

const mediaItems = [
  { image: FirstImage, href: "https://www.facebook.com/watch/live/?v=708190700044584", title: "CNBCTV18 Live panel discussion- Sharing about the it's Cool to be Kind" },
  { image: SecondImage, href: "https://www.magzter.com/stories/Health/Life-Positive/Caring-through-kindness", title: "Life Positive – Caring through Kindness" },
  { image: ThirdImage, href: "https://lonepack.org/blog/index.php/2019/11/29/lonepack-conversations-nirmala-mehendale-kindness-unlimited/", title: "LonePack Conversations – Nirmala Mehendale & Kindness Unlimited" },
  { image: FourthImage, href: "https://www.sujatawde.com/2020/11/2000-vikramgad-residents-receive-cups.html?m=1", title: "Spirit of Mumbai – 2000 VIKRAMGAD RESIDENTS RECEIVE CUPS OF KINDNESS!" },
  { image: FifthImage, href: "https://www.hindustantimes.com/cities/volunteer-for-ngo-in-city-get-tickets-to-ankur-tiwari-tanmay-bhat-concert/story-40Y6MSJNugkkXT6oa78XiM.html", title: "Hindustan Times – Encash your kind deeds for a concert in the city" },
  { image: SixthImage, href: "https://www.dnaindia.com/mumbai/report-carter-road-marks-world-kindness-week-with-a-flash-mob-2033618", title: "DNA – Carter Road marks World Kindness Week with a flash mob" },
  { image: SeventhImage, href: "https://thecsrjournal.in/csr-society-tea-vikramgad-families/", title: "CSR – Society Tea runs tea drive in Vikramgad district" },
  { image: EighthImage, href: "https://issuu.com/gentletude/docs/kindnessindia_single", title: "Issuu – Kindness in India. The Colors of Altruism." },
  { image: NinethImage, href: "https://m.timesofindia.com/life-style/spotlight/an-initiative-for-the-greater-good/amp_articleshow/79197833.cms", title: "Times of India – An initiative for the greater good" },
  { image: TenthImage, href: "https://www.linkedin.com/posts/anshuman_kindness-at-the-workplace-a-conversation-activity-6745335025232945152-T9Xu", title: "LinkedIn – Kindness at the Workplace A Conversation Activity" },
];

const Newsroom = () => (
  <PageLayout>
    <PageHero title="Newsroom" subtitle="Coverage, research, and stories about Kindness Unlimited's work." light />
    <section className="ku-section bg-white">
      <div className="ku-container space-y-12">
        {articles.map((article, i) => (
          <FadeIn key={article.title} delay={i * 0.08}>
            <article className="ku-card overflow-hidden grid md:grid-cols-3 gap-0">
              <img src={article.image} alt={article.title} className="w-full h-full min-h-[240px] object-cover md:col-span-1" />
              <div className="p-8 md:col-span-2 flex flex-col">
                <h2 className="font-display text-2xl font-bold text-ku-royal mb-4">{article.title}</h2>
                <p className="font-body text-gray-600 leading-relaxed flex-1 whitespace-pre-line">{article.body}</p>
                <a href={article.pdf} className="ku-btn-outline inline-flex items-center gap-2 mt-6 w-fit">
                  <Download className="w-4 h-4" />
                  Download PDF
                </a>
              </div>
            </article>
          </FadeIn>
        ))}
      </div>
    </section>
    <section className="ku-section bg-ku-cream">
      <div className="ku-container">
        <FadeIn>
          <h2 className="ku-heading-lg mb-10">Media</h2>
        </FadeIn>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {mediaItems.map((item, i) => (
            <FadeIn key={item.title} delay={i * 0.04}>
              <a
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className="group ku-card overflow-hidden block h-full hover:border-ku-lavender/40 border-2 border-transparent"
              >
                <img src={item.image} alt="" className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="p-5">
                  <p className="font-body text-sm text-gray-700 group-hover:text-ku-royal transition-colors flex items-start gap-2">
                    {item.title}
                    <ExternalLink className="w-4 h-4 flex-shrink-0 text-ku-violet" />
                  </p>
                </div>
              </a>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  </PageLayout>
);

export default Newsroom;
